import { css, Global } from '@emotion/react';

import { languages } from '@/context/redux/LanguageProvider';
import { useAppSelector } from '@/context/redux/store';

export const Fonts = () => {
  const { value } = useAppSelector((state) => state.language);

  return (
    <Global
      styles={css`
        @import url(//spoqa.github.io/spoqa-han-sans/css/SpoqaHanSansNeo.css);
        body {
          font-family: ${value === languages.EN ? 'Spoqa Han Sans Neo' : 'Spoqa Han Sans Neo'};
        }
      `}
    />
  );
};
